import { moveToStep } from 'features/billing/create_subscription_slice'
import { steps } from 'features/billing/modals/subscription_modal/steps'

export const legacyPlanWarning = (dispatch, {
  isLegacyPlan,
  unableToChangeTier,
}) => (
  ({ action = () => null }) => {
    if (isLegacyPlan && !unableToChangeTier) {
      dispatch(moveToStep({
        step: steps.LEGACY_PLAN_MODAL,
        stepOptions: {
          onSuccess: () => action()
        }
      }))
      return true
    }

    action()

    return false
  }
)
